import { PageNotFound404 } from "pages/public/PageNotFound404";
import { PublicPage } from "./PublicPage";

interface IShowNotFoundOrUnAuthorizedUiBasedOnStatusCodeProps {
    statusCode: number;
}

export const ShowNotFoundOrUnAuthorizedUiBasedOnStatusCode = ({ statusCode }: IShowNotFoundOrUnAuthorizedUiBasedOnStatusCodeProps): JSX.Element => {

    if (statusCode === 401 || statusCode === 403) {
        return (
            <PublicPage
                title={`${statusCode} – ${statusCode === 401 ? "Unauthorized" : "Access Denied"}`}
                description="Need assistance? Visit our"
                reasons={[
                    "You don't have permission to access this page",
                    "You’re not logged in or your session has expired",
                    "Your account doesn’t have the required privileges"
                ]} />
        );
    }

    if (statusCode === 404) {
        return <PageNotFound404 statusCode={statusCode} />
    }

    return <></>;
}
